<template>
  <div>
    <v-app-bar color="surface" elevation="1">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        PowerText
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip text="Support Center" location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn
            icon
            v-bind="props"
            :href="supportCenterUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>
      </v-tooltip>

      <v-menu location="bottom" min-width="200px">
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props">
            <v-icon>mdi-apps</v-icon>
          </v-btn>
        </template>
        <v-card style="padding-top: 20px">
          <h3 style="margin-left: 20px">Switch to</h3>
          <v-list density="compact">
            <v-list-item
              :href="app.link"
              v-for="app in powersuiteApps"
              :key="app.name"
            >
              <template v-slot:prepend>
                <v-icon>mdi-apps</v-icon>
              </template>
              <v-list-item-title>{{ app.name }} </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer">
      <div
        class="placeholder"
        style="
          background-color: rgb(var(--v-theme-surface));
          height: 64px;
          width: 100%;
          border-right: 1px solid #f1f1f1;
          position: absolute;
          top: 0;
          left: 0;
        "
      ></div>

      <v-menu location="bottom" min-width="200px">
        <template v-slot:activator="{ props }">
          <v-btn
            icon
            v-bind="props"
            style="
              margin-top: 25px;
              margin-bottom: 15px;
              width: 72px;
              height: 72px;
              margin-left: 92px;
            "
          >
            <v-avatar color="secondary" size="72">
              <span v-if="initials" class="text-white text-h5">{{
                initials
              }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <div class="pa-4 justify-center">
            <div class="mx-auto text-center">
              <v-avatar color="secondary">
                <span v-if="initials" class="text-white text-h5">{{
                  initials
                }}</span>
              </v-avatar>
              <h3 style="margin-top: 10px" v-if="user">
                {{ user.username }}
              </h3>
              <p v-if="user" class="text-caption mt-1">
                {{ user.organisation }}
              </p>
              <v-divider class="my-3"></v-divider>
              <v-btn color="primary" class="mb-2" @click="handleLogout()">
                Logout
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-menu>

      <v-divider />

      <v-list
        density="compact"
        v-for="menuItem in menuItems"
        :key="menuItem.title"
      >
        <v-list-group v-if="menuItem.children" :value="menuItem.title">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" @click.stop="goto(menuItem.link)">
              <template v-slot:prepend>
                <v-icon>{{ menuItem.icon }}</v-icon>
              </template>
              <v-list-item-title>{{ menuItem.title }} </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            v-for="child in menuItem.children"
            :key="child.title"
            :to="child.link"
            :class="child.link === $route.path ? 'v-list-item--active' : ''"
            class="ml-8"
            link
          >
            <template v-slot:prepend>
              <v-icon>{{ child.icon }}</v-icon>
            </template>
            <v-list-item-title>
              {{ child.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-item v-else :to="menuItem.link">
          <template v-slot:prepend>
            <v-icon>{{ menuItem.icon }}</v-icon>
          </template>
          <v-list-item-title>
            {{ menuItem.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  data() {
    let _menuItems = [
      {
        title: "Home",
        icon: "mdi-home",
        link: "/home",
      },
      {
        title: "Generative texts",
        icon: "mdi-robot-outline",
        link: "/generative-text",
      },
      {
        title: "Translate texts",
        icon: "mdi-translate",
        link: "/translations",
      },
      {
        title: "Templates",
        icon: "mdi-package-variant-closed",
        link: "/templates",
      },
      {
        title: "Dictionaries",
        icon: "mdi-book",
        link: "/dictionaries",
      },
      {
        title: "API",
        icon: "mdi-api",
        link: "/api/settings",
      },
    ];

    return {
      drawer: true,
      allMenuItems: _menuItems,
      actionMenuItems: [],
      classesWithVersions: [],
      classesVisible: false,
    };
  },
  mounted() {
    this.$store.dispatch("fetchUser").catch(() => undefined);
    axios.get("/api/powersuiteapps").then(({ data }) => {
      this.$store.dispatch("updatePowersuiteApps", data.powersuiteApps);
    });
  },
  watch: {
    classes: function (value) {
      this.classesWithVersions = value.filter(
        (c) => c.versions && c.versions.length,
      );
      this.classesVisible = this.classesWithVersions.length > 0;
    },
  },
  computed: {
    theme() {
      return this.$vuetify.theme.current.dark ? "dark" : "light";
    },
    logoSrc() {
      return `/logos/PowerText-logo-${this.theme}.svg`;
    },
    user() {
      return this.$store.getters.getUser;
    },
    powersuiteApps() {
      return this.$store.getters.getPowersuiteApps;
    },
    supportCenterUrl() {
      const fallbackUrl = "https://powersuite.ai/nl/support-centrum";
      return import.meta.env.VITE_SUPPORT_CENTER_URL || fallbackUrl;
    },
    templateModuleEnabled() {
      return this.$store.getters.templateModuleEnabled;
    },
    menuItems() {
      return this.allMenuItems.filter((item) => {
        if (item.link === "/templates") {
          return this.templateModuleEnabled;
        }
        if (
          item.children &&
          item.children.some((child) => child.link === "/templates")
        ) {
          return this.templateModuleEnabled;
        }
        return true;
      });
    },
    initials() {
      if (!this.user) return undefined;

      return this.user.username
        .split(" ")
        .map((n) => n[0])
        .join("");
    },
  },
  methods: {
    /**
     * Removes the PowerSuite cookies with an explicit path and domain: vue3-cookies only formats
     * the `; domain=` and `; path=` attributes for arguments, not for configured defaults.
     */
    handleLogout() {
      const domain = import.meta.env.DEV ? undefined : ".mlc-services.com";
      this.$cookies.remove(import.meta.env.VITE_AUTH_TOKEN_ID, "/", domain);
      this.$cookies.remove(import.meta.env.VITE_REFRESH_TOKEN_ID, "/", domain);
      window.location.reload();
    },
    goto(link) {
      if (this.$route.path !== link) {
        this.$router.push({ path: link });
      }
    },
  },
};
</script>

<style lang="scss"></style>
